export default {"src":"/_next/static/media/double-bars-icon.39c4612c.svg","height":70,"width":44};